import { Pattern } from 'fabric';

import getFrostedFilmPattern, { FROSTED_FILM_COLOR } from './getFrostedFilmPattern';

// Stopgap allow-list of the one gang-sheet customer model until products carry a gang-sheet marker.
// Must match the dashboard's libs/core/product-details/constants/product-uid-gang-sheet-reg-exp.ts.
const GANG_SHEET_PRODUCT_UID_REGEXP = /_davidsharp_dtf_/;

export type PageFill = string | Pattern;

export function isGangSheetProductUid(productUid?: string): boolean {
  return !!productUid && GANG_SHEET_PRODUCT_UID_REGEXP.test(productUid);
}

// DTF film prints no background, so white artwork would vanish on a white page.
export function getFilmFill(): PageFill {
  return getFrostedFilmPattern() ?? FROSTED_FILM_COLOR;
}

export function getNonPrintingPageFill(productUid?: string): PageFill | undefined {
  return isGangSheetProductUid(productUid) ? getFilmFill() : undefined;
}
